import { createSelector } from "@reduxjs/toolkit";

import type { MultilingualNodeConfig } from "../../schemas/index.ts";
import { primaryContentLanguageCodeSelector } from "../managed/selectors/languageSelectors.ts";
import { setNodeMultilingualPropertiesCreate } from "../multilingual/index.ts";
import { updateNodeConfigAction } from "../reducer/index.ts";
import { getMultilingualNodeConfigSelector } from "./nodeConfigSelectors.ts";
import { dispatchParamSelector } from "./paramSelectors.ts";

const setMultilingualNodeConfigSelector = createSelector(
  [dispatchParamSelector],
  (dispatch) => (id: number, config: MultilingualNodeConfig) => dispatch(updateNodeConfigAction({ id, config })),
);

export const setNodeMultilingualPropertiesSelector = createSelector(
  [getMultilingualNodeConfigSelector, setMultilingualNodeConfigSelector, primaryContentLanguageCodeSelector],
  (getConfig, setConfig, primaryLanguageCode) =>
    setNodeMultilingualPropertiesCreate({ getConfig, setConfig, primaryLanguageCode }),
);
